import { GESTION_OPERATIVA_SET_MONTO } from './constants'

export function setMonto(amount) {
  return (dispatch) => {

    dispatch({
      type: GESTION_OPERATIVA_SET_MONTO,
      data: {
        amount_2b_financed: parseFloat(amount)
      },
    })
  }
}

export function reducer(state, action) {
  if (action.type === GESTION_OPERATIVA_SET_MONTO) {
      return {
        ...state,
        sale: {
            ...state.sale,
            amount_2b_financed: action.data.amount_2b_financed,
        }
      }
  }
  else {
      return state
  }
}
